import { Location } from 'react-router-dom';

function removeLangCode(path: string): string {
	// Check if the path is just a language code (e.g., "/sv")
	if (/^\/[a-z]{2}$/.test(path)) {
		return '/';
	}
	// The regex finds a pattern like '/xx/' at the start of the string
	// and replaces it with a single '/'
	return path.replace(/^\/[a-z]{2}\//, '/');
}

/**
 * A hook that returns the main location from the current window location pathname.
 *
 * This hook processes the current URL pathname by removing any language code prefixes,
 * resulting in the main location path. This is particular useful inside sidebar/modal context where useLocation doesnt give you mainLocation
 *
 * @returns The main location path as a string, with language code (if any) removed.
 *
 * @example
 * If window.location.pathname is "/en/casino/explore"
 * const mainLocation = useMainLocation();
 *  mainLocation will be  { pathname: "/casino/explore", search: "", state: null, hash: "", key: "" }
 */
const useMainLocation = (): Location => {
	const pathname = removeLangCode(window.location.pathname);
	const { search } = window.location;

	return {
		pathname,
		search,
		state: {},
		hash: window.location.hash,
		key: ''
	};
};

export default useMainLocation;
